export default {
    index: {
        listagem_setores: 'Listagem de Setores',
        setor_nao_encontrado: 'Nenhum setor encontrado',
        criar_setor: 'Criar Setor',
        editar: 'Editar',
        nome: 'Nome',
        apelido: 'Apelido'
    },
    form: {
        setores: 'Setores',
        unidade_atendimento_principal: 'Unidade de Atendimento Principal',
        informacoes: 'Informações',
        nome: 'Nome',
        nome_descricao: 'Nome do Setor',
        mnemonico: 'Mnemônico',
        mnemonico_descricao: 'Mnemônico do Setor',
        veus_id_descricao: 'ID do Setor no Veus Saúde',
        vinculo: 'Vínculo',
        unidade_atendimento_principal_descricao: 'Unidade de Atendimento Principal',
        setor_criado_sucesso: 'Setor criado com sucesso!',
        setor_atualizado_sucesso: 'Setor atualizado com sucesso!'
    }
}